<div class="mainDiv">
<table class="full">
  <tbody>
  <tr>
  <td class="col1">
  <mat-spinner *ngIf="!loaded"></mat-spinner>
  <div class="cardList">
    <mat-card class="mat-card" [ngClass]="[!isSmallView?'sm':'md']" *ngFor="let product of products">
      <mat-card-content *ngIf="!hasSubscription(product.itemNumber)">
        <div><b>{{getProductName(product.itemNumber)}}</b></div>
        <!--<div>{{product.productType}}</div> -->
        <div>
          <div><img src="{{getProductImage(product.itemNumber)}}"/></div>
          <!--<div>{{product.description1}}</div> -->
          <br>
          <div>List Price: {{getProductPrice(product.name, 'NONMBR')}}</div>
          <div>Member: {{getProductPrice(product.name, 'MEMBER')}}</div><br> 
        </div>                
      </mat-card-content>  
      <mat-card-actions *ngIf="!hasSubscription(product.itemNumber)">
        <div class="btn-right"><button mat-fab extended class="btn-cls md" [routerLink]="['/product', product.itemNumber]">Purchase</button></div>
      </mat-card-actions>            
      <mat-card-content *ngIf="hasSubscription(product.itemNumber)">
        <div><b>{{getProductName(product.itemNumber)}}</b></div>
        <!--<div>{{getSubscription(product.itemNumber).productType}}</div> -->
        <div>
          <div><img src="{{getProductImage(product.itemNumber)}}"/></div>
          <div>{{getSubscription(product.itemNumber).term}}</div>
          <div>Users: {{getSubscription(product.itemNumber).userCount}}</div>
          <div *ngIf="!isAdmin">Admin: {{getSubscription(product.itemNumber).adminName}}</div>
          <div *ngIf="!isAdmin">Email: {{getSubscription(product.itemNumber).adminEmail}}</div>
          <div>Start Date:{{getSubscription(product.itemNumber).startDate}}</div>
          <div>Exp Date: {{getSubscription(product.itemNumber).expireDate}}</div>
          <div>Amount: {{getSubscription(product.itemNumber).totalAmount}}</div>
          <br>
        </div>
      </mat-card-content>
      <mat-card-actions *ngIf="hasSubscription(product.itemNumber)">
        <div class="btn-right" *ngIf="isAdmin">
          <button mat-fab extended class="btn-cls md" (click)="dialog.open(moreInfo)">More Info</button><br/><br/>      
          <button mat-fab extended class="btn-cls md" (click)="renew(product.itemNumber)">Renew</button>
        </div>
        <div class="btn-right" *ngIf="!isAdmin">
          <button mat-fab extended class="btn-cls md" (click)="viewProduct(product.itemNumber)">View</button><br/><br/>      
          <button mat-fab extended class="btn-cls md" (click)="accessProduct()">Access RBRVS</button>
        </div>
      </mat-card-actions>           
    </mat-card>
    <span *ngIf="loaded">
      <mat-card class="mat-card" [ngClass]="[!isSmallView?'sm':'md']" >
        <mat-card-content>
          <div><b>{{product2.name}} Online</b></div>
          <br>
          <div>
            <div><img src="{{getProductImage(product2.itemNumber)}}"/></div>
            <div>{{product2.description}}</div><br>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <div class="btn-right"><button mat-fab extended class="btn-cls md" (click)="navigateToProduct()">View</button></div>
        </mat-card-actions>        
      </mat-card>
    </span>
    <span *ngIf="loaded">
      <mat-card class="mat-card" [ngClass]="[!isSmallView?'sm':'md']" >
        <mat-card-content>
          <div><b>{{product3.name}} Online</b></div>
          <div>
            <div><img src="{{getProductImage(product3.itemNumber)}}"/></div>
            <div>{{product3.description}}</div><br>
          </div>
        </mat-card-content>  
        <mat-card-actions>
          <div class="btn-right"><button mat-fab extended class="btn-cls md" (click)="navigateToProduct()">View</button></div>
        </mat-card-actions>
        
      </mat-card> 
    </span>
  </div>
</td>
<td [ngClass]="[!isSmallView && !isTabletView?'col2':'col-hide']">
  <mat-card class="mat-card adm" *ngIf="isAdmin"> 
    <mat-card-content>
      <div><b>Manage RBRVS DataManager Users</b></div><br>
      <div>As a purchaser you can designate user(s) as secondary administrators to manage license seats, and or designate user(s) for product licenses purchased.</div><br>
      <div><button mat-fab extended class="btn-cls" [routerLink]="['/manage-admins']">Manage RBRVS DataManager Users</button></div>
    </mat-card-content>        
  </mat-card>
</td>
</tr>
</tbody>
</table><br>
<div *ngIf="isSmallView && isAdmin">
  <mat-card class="mat-card md"> 
    <mat-card-content>
      <div><b>Manage RBRVS DataManager Users</b></div><br>
      <div>As a purchaser you can designate user(s) as secondary administrators to manage license seats, and or designate user(s) for product licenses purchased.</div><br>
      <div><button mat-fab extended class="btn-cls" [routerLink]="['/manage-admins']">Manage RBRVS DataManager Users</button></div>
    </mat-card-content>      
  </mat-card>
</div>
<div class="cardList" *ngIf="isTabletView && isAdmin"> 
  <mat-card class="mat-card adm" >
    <mat-card-content>
      <div><b>Manage RBRVS DataManager Users</b></div><br>
      <div>As a purchaser you can designate user(s) as secondary administrators to manage license seats, and or designate user(s) for product licenses purchased.</div><br>
      <div><button mat-fab extended class="btn-cls" [routerLink]="['/manage-admins']">Manage RBRVS DataManager Users</button></div>
    </mat-card-content>    
  </mat-card>
</div>

<ng-template #moreInfo>
  <div class="dialogCls"> 
    <mat-dialog-title class="dialogTitle">
      <button mat-icon-button mat-dialog-close class="float-right"><mat-icon>close</mat-icon></button>      
    </mat-dialog-title>   
    <mat-dialog-content>
        <div>
          <div><strong>How to Renew Your Subscription:</strong></div>
          <ol>
            <li>Click the Renew link to be redirected to the Shopping Cart.</li>
            <li>In the Shopping Cart, adjust the number of licensed users (1–10) by updating the quantity.</li>
            <li>You can renew at any time before your subscription expires. </li>
          </ol>   
          <div><strong>Important Notes:</strong></div>
          <ul style="list-style-type:disc;">
            <li>Renewals are accepted by credit card only.</li>
            <li>All transactions are subject to the User License Agreement.</li>
          </ul>
          <div><strong>Need Help?</strong></div>
          <div>
            Contact the Unified Service Center at 800-621-8335, Monday–Friday, 8:30 AM–4:45 PM CT.
          </div>           
        </div>
    </mat-dialog-content>
  </div>  
</ng-template>
<div class="contactUsDiv">
  <span>
    <a href={{contactUsUrl}} target="_blank">Need Help? </a>Contact Us
  </span>
</div>
</div>